import map from 'lodash/map';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { selectQueueState } from 'app/utils/reselect';
import { notificationActions } from 'components/notifications/actions/notification';
import { readWidget, updateWidget, validateWidgetName, } from 'components/settings/actions/chatWidgets';
import { getAllQueues } from 'components/settings/actions/queues';
import { hasFeature } from 'components/shared/featureFlag';
import { withTags } from 'hocs';
import { withRouter } from 'hocs/router';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { chatFlowActions } from '../actions/chatFlow';
import PowerChatFlow from '../components/PowerChatFlow';
const { notificationAdd } = notificationActions;
const { chatFlowAdd, chatFlowClearState, chatFlowEdit, chatFlowGet } = chatFlowActions;
const getId = (_state, ownProps) => ownProps.params.flowId;
const getNodes = (state) => state.chatNodes.nodes;
const getName = (state) => state.chatFlow.name;
const selectFlowData = createSelector([getId, getNodes, getName], (id, nodes, name) => {
    return {
        actions: map(nodes, (n) => n),
        active: true,
        created_at: '',
        id: id !== null && id !== void 0 ? id : '',
        name,
        updated_at: '',
    };
});
const mapStateToProps = (state, ownProps) => {
    return {
        chatWidget: state.settings.chatWidget,
        flowData: selectFlowData(state, ownProps),
        hasTagNode: true,
        isCanvasEnabled: hasFeature(state, 'routing-use-canvas'),
        id: getId(state, ownProps),
        name: state.chatFlow.name,
        queuesState: selectQueueState(state),
        status: state.chatFlow.meta.asyncStatus,
        widget_id: state.chatFlow.widget_id,
        agentDisplayName: state.settings.profile.profile.name,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addFlow: bindActionToPromise(dispatch, chatFlowAdd),
        fetchFlow: bindActionToPromise(dispatch, chatFlowGet),
        getAllQueues: () => dispatch(getAllQueues()),
        chatFlowClearState: () => dispatch(chatFlowClearState()),
        getWidget: (widgetId) => dispatch(readWidget(widgetId)),
        notificationAdd: (payload) => dispatch(notificationAdd(payload)),
        updateFlow: bindActionToPromise(dispatch, chatFlowEdit),
        updateWidget: (widget) => dispatch(updateWidget(widget)),
        validateWidgetName: (name) => dispatch(validateWidgetName(name)),
    };
};
export default withTags(withRouter(connect(mapStateToProps, mapDispatchToProps)(PowerChatFlow)));
